export enum NOTIFICATION_TYPE {
  PatientQrCodeScanned = 'PatientQrCodeScanned',
  GeneralInfoUpdated = 'GeneralInfoUpdated',
  LivingWillUpdated = 'LivingWillUpdated',
  CriticalInfoUpdated = 'CriticalInfoUpdated',
  InvitationStatusUpdated = 'InvitationStatusUpdated',
}

export enum NOTIFICATION_SECTION {
  PersonalInfo = 'PersonalInfo',
  Notarization = 'Notarization',
  MentalHealthPreferences = 'MentalHealthPreferences',
  AdditionalMentalHealthPreferences = 'AdditionalMentalHealthPreferences',
  InstructionsFollowing = 'InstructionsFollowing',
  ProxyInfo = 'ProxyInfo',
  FirstWitnessInfo = 'FirstWitnessInfo',
  SecondWitnessInfo = 'SecondWitnessInfo',
}

export enum NOTIFICATION_PROPS_DICTIONARY {
  firstName = 'First name',
  lastName = 'Last name',
  state = 'State',
  address = 'Address',
  city = 'City',
  zip = 'ZIP',
  sex = 'Sex',
  ssn = 'SSN',
  gender = 'Gender',
  educationDegree = 'Degree',
  fieldOfStudy = 'Field of study',
  graduatedSchool = 'School',
  graduationDate = 'Education start date',
  entryStartDate = 'Education end date',
  ethnicity = 'Ethnicity',
  religion = 'Religion',
  dateOfBirth = 'Date of birth',
  contactPhone = 'Mobile phone',
  phoneNumber = 'Mobile phone',
  workPhone = 'Work phone',
  homePhone = 'Home phone',
  medicalRecordNumber = 'Medical record number',
  otherInsurance = 'Other insurance number',
  medicareNumber = 'Medicare number',
  medicalIdNumber = 'Medic ID number',
  mentalHealthPreferences = 'Mental Health Preferences',
  additionalMentalHealthPreferences = 'Additional Mental Health Preferences',
  relationship = 'Relationship',
  isNextOfKin = 'Is a Next-of-kin?',
  notaryId = 'Notary id',
  disabilities = 'Disabilities',
  instructionsFollowing = 'How would you like us to follow your instructions?',
}
